var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/feedback/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"csc-feedback _section\">\n  <div class=\"csc-feedback _bubble\">\n    <div class=\"csc-feedback _box\">\n      <div class=\"csc-feedback _title -article\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "boxTitle"), env.opts.autoescape);
output += "</div>\n      <div class=\"csc-feedback _body\">\n\n        <div class=\"csc-feedback _rating\" id=\"csc-feedback-rating\">\n          <div class=\"csc-feedback _rated-type\" id=\"csc-feedback-current-rating-type\"></div>\n        </div>\n\n        <div class=\"csc-feedback _options\">\n\n          <div id=\"csc-feedback-input-screen\" class=\"csc-feedback -hidden\">\n            <div class=\"csc-feedback _reasons\">\n              <div class=\"csc-feedback _reason-mandatory\" id=\"csc-feedback-reason-mandatory\"></div>\n              <div class=\"csc-feedback _reason-options\" id=\"csc-feedback-reason-options\"></div>\n            </div>\n            \n            <textarea\n              class=\"csc-feedback _comment-input\"\n              placeholder=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "enterComments"), env.opts.autoescape);
output += "\n              maxLength=\"500\"\n              id=\"csc-feedback-comment-input\"\n            ></textarea>\n            \n            <div class=\"csc-feedback _actions\">\n              <div class=\"csc-feedback _button -disabled\" id=\"csc-feedback-submit\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "submitButtonText"), env.opts.autoescape);
output += "</div>\n            </div>\n          </div>\n\n          <div id=\"csc-feedback-end-screen\" class=\"csc-feedback -hidden\">\n            <div class=\"csc-feedback _reason-options\" id=\"csc-feedback-chosen-reasons\"></div>\n            <div class=\"csc-feedback _comment\" id=\"csc-feedback-comment\">\n              “<span id=\"csc-feedback-comment-content\"></span>”\n            </div>\n            <div class=\"csc-feedback _thank\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "thanks"), env.opts.autoescape);
output += "</div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/feedback/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/module/feedback/tpl.html
// module id = 238
// module chunks = 0 1